<template>
  <div class="inventory-line-serial-panel">
    <div v-if="!readonly" style="margin-bottom:8px;">
      <el-input
        ref="scanInput"
        v-model="scanCode"
        size="small"
        placeholder="扫描序列号后回车"
        clearable
        style="width:220px;"
        @keyup.enter.native="onScan"
      />
      <el-button type="primary" size="small" style="margin-left:8px;" @click="onScan">添加</el-button>
    </div>
    <el-tag
      v-for="(sn, idx) in serialNos"
      :key="sn + idx"
      size="small"
      :closable="!readonly"
      style="margin:0 6px 6px 0;"
      @close="removeSerial(idx)"
    >{{ sn }}</el-tag>
    <span v-if="!serialNos.length" style="color:#909399;font-size:12px;">暂无序列号</span>
    <span v-if="expectedQty > 0" style="margin-left:12px;color:#606266;font-size:12px;">已扫 {{ serialNos.length }} / {{ expectedQty }}</span>
  </div>
</template>

<script>
export default {
  name: 'InventoryLineSerialPanel',
  props: {
    value: { type: Array, default: () => [] },
    expectedQty: { type: Number, default: 0 },
    readonly: { type: Boolean, default: false }
  },
  data() {
    return { scanCode: '' }
  },
  computed: {
    serialNos() { return this.value || [] }
  },
  methods: {
    onScan() {
      const code = (this.scanCode || '').trim()
      if (!code) return
      if (this.serialNos.includes(code)) {
        this.$message.warning('序列号已存在')
        this.scanCode = ''
        return
      }
      if (this.expectedQty > 0 && this.serialNos.length >= this.expectedQty) {
        this.$message.warning('序列号数量已达行数量上限')
        this.scanCode = ''
        return
      }
      this.$emit('input', this.serialNos.concat([code]))
      this.scanCode = ''
      this.$nextTick(() => {
        if (this.$refs.scanInput) this.$refs.scanInput.focus()
      })
    },
    removeSerial(idx) {
      const next = this.serialNos.slice()
      next.splice(idx, 1)
      this.$emit('input', next)
    }
  }
}
</script>
